import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  HostBinding,
  Input,
  OnDestroy,
  OnInit,
  Output,
  QueryList,
  ViewChildren
} from '@angular/core';
import {finalize} from 'rxjs/operators';
import {animationFrameScheduler, Subscription} from 'rxjs';

import {Example} from '../../shared/models/example.model';
import {ExampleService} from '../../shared/services/example/example.service';
import {OptionService} from '../../shared/services/option/option.service';
import {VoiceService} from '../../shared/services/voice/voice.service';

const MIN_WORD_ITEM_REMAINING_WIDTH = 6;

@Component({
  selector: 'app-example-detail',
  templateUrl: './example-detail.component.html',
  styleUrls: ['./example-detail.component.scss']
})
export class ExampleDetailComponent implements OnInit, AfterViewInit, OnDestroy {
  @HostBinding('style.display') display = 'block';
  @ViewChildren('listWord', {read: ElementRef}) listWords: QueryList<ElementRef>;
  @Input() example_id: string;
  @Input() height: number;
  @Input() showHelpButton = false;
  @Output() closeDetail = new EventEmitter<void>();
  @Output() openExampleHelp = new EventEmitter<void>();

  public example: Example | null = null;
  public classFull = false;
  private loadDetail$: Subscription | null = null;
  private playExample$: Subscription | null = null;
  private listWords$: Subscription | null = null;

  constructor(
    private exampleSvc: ExampleService,
    private option: OptionService,
    private voice: VoiceService,
  ) {
  }

  ngOnInit(): void {
    this.loadDetail$ = this.exampleSvc.GetDetail(this.example_id).subscribe(
      data => {
        this.example = data;
        if (this.option.autoPlay && this.example?.example_voice) {
          this.playExample$ = this.voice.PlayExample(this.example.id, this.example.example_voice).pipe(
            finalize(() => this.playExample$ = null)
          ).subscribe();
        }
      },
      err => console.error(err),
    );
  }

  ngAfterViewInit(): void {
    animationFrameScheduler.schedule(() => this.updateClassFull(this.listWords));
    this.listWords$ = this.listWords.changes.subscribe((listWords: QueryList<ElementRef>) => {
      animationFrameScheduler.schedule(() => this.updateClassFull(listWords));
    });
  }

  ngOnDestroy(): void {
    if (this.loadDetail$) {
      this.loadDetail$.unsubscribe();
      this.loadDetail$ = null;
    }
    if (this.playExample$) {
      this.playExample$.unsubscribe();
      this.playExample$ = null;
    }
    if (this.listWords$) {
      this.listWords$.unsubscribe();
      this.listWords$ = null;
    }
  }

  public onClose(): void {
    this.closeDetail.emit();
  }

  public onClickHelp(event: MouseEvent): void {
    event.stopPropagation();
    event.preventDefault();
    this.openExampleHelp.emit();
  }

  private updateClassFull(listWords: QueryList<ElementRef>): void {
    this.classFull = false;

    for (let word of listWords) {
      const firstChild = word.nativeElement.firstElementChild;
      if (!firstChild) {
        continue;
      }

      const wordWidth = word.nativeElement.getBoundingClientRect().width;
      const firstChildWidth = Math.max(firstChild.getBoundingClientRect().width, firstChild.scrollWidth);
      if (firstChildWidth > wordWidth || wordWidth - firstChildWidth < MIN_WORD_ITEM_REMAINING_WIDTH) {
        this.classFull = true;
        break;
      }
    }
  }
}
